//#region src/js/toggle-button.js
var defaultOptions = {
	classToToggle: "toggle--is-active",
	triggerToggle: "",
	target: "body",
	onHover: false,
	hoverDelay: 0,
	preventDefault: true,
	stopPropagation: true,
	ariaExpanded: false
};
function debounce(callback, delay) {
	let timeoutId;
	return (...args) => {
		window.clearTimeout(timeoutId);
		timeoutId = window.setTimeout(() => callback(...args), delay);
	};
}
var ToggleButton = class extends HTMLElement {
	connectedCallback() {
		this.options = this.getOptions();
		this.targetElement = document.querySelector(this.options.target);
		if (!this.targetElement) return;
		this.handleClick = this.handleClick.bind(this);
		this.handleMouseEnter = debounce(() => this.add(), this.options.hoverDelay);
		this.handleMouseLeave = debounce(() => this.remove(), this.options.hoverDelay);
		this.addEventListener("click", this.handleClick);
		if (this.options.onHover) {
			this.addEventListener("mouseenter", this.handleMouseEnter);
			this.addEventListener("mouseleave", this.handleMouseLeave);
		}
	}
	disconnectedCallback() {
		this.removeEventListener("click", this.handleClick);
		this.removeEventListener("mouseenter", this.handleMouseEnter);
		this.removeEventListener("mouseleave", this.handleMouseLeave);
	}
	getOptions() {
		if (!this.dataset.options) return { ...defaultOptions };
		try {
			return {
				...defaultOptions,
				...JSON.parse(this.dataset.options)
			};
		} catch (error) {
			console.error("Invalid toggle-button data-options JSON.", error);
			return { ...defaultOptions };
		}
	}
	handleClick(event) {
		if (this.options.preventDefault) event.preventDefault();
		if (this.options.stopPropagation) event.stopPropagation();
		this.toggle();
	}
	add() {
		this.targetElement.classList.add(this.options.classToToggle);
		this.toggleTriggerClass(true);
		this.updateAriaExpanded(true);
	}
	remove() {
		this.targetElement.classList.remove(this.options.classToToggle);
		this.toggleTriggerClass(false);
		this.updateAriaExpanded(false);
	}
	toggle() {
		if (this.targetElement.classList.contains(this.options.classToToggle)) {
			this.remove();
			return;
		}
		this.add();
		this.focusSearchInput();
	}
	toggleTriggerClass(shouldAddClass) {
		if (!this.options.triggerToggle) return;
		this.classList.toggle(this.options.triggerToggle, shouldAddClass);
	}
	updateAriaExpanded(isExpanded) {
		if (!this.options.ariaExpanded) return;
		this.setAttribute("aria-expanded", isExpanded.toString());
	}
	focusSearchInput() {
		if (!this.targetElement.querySelector("input[type=\"search\"]")) return;
		document.getElementById("Search")?.focus();
	}
};
window.ToggleElementClass = ToggleButton;
if (!customElements.get("toggle-button")) customElements.define("toggle-button", ToggleButton);
//#endregion
